import {
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCheckbox,
  IonIcon,
  IonText,
} from "@ionic/react";
import { bookmarkOutline, calendarOutline, personOutline } from "ionicons/icons";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
// Types
import { Document } from "../../../@types/document";
import { DocumentStatusTag } from "../../../components/Document/DocumentStatusTag";
import { selectSegmentSelected } from "../../../store/documentsSignerList/selectors/selectSegmentSelected";
import { setCheck } from "../../../store/documentsSignerList";
import { selectMassiveSign } from "../../../store/documentsSignerList/selectors/selectMassiveSign";
import api from "../../../utils/api";

interface CardItemListProps {
  document: Document;
}

export const DocumentCardItemList: React.FC<CardItemListProps> = ({ document }) => {
  const massiveSign = useSelector(selectMassiveSign);
  const dispatch = useDispatch();
  const [hasFocus, setHasFocus] = useState(false);
  const segment = useSelector(selectSegmentSelected);
  const [thumbSrc, setThumbSrc] = useState('https://programacion.net/files/article/20161110041116_image-not-found.png');

  useEffect(() => {
    const fetchThumbnail = async () => {
      if (document.thumbArchive) {
        try {
          const token = localStorage.getItem('token');
          const response = await fetch(`${api.baseURL}archive/${document.thumbArchive?.id}`, {
            headers: {
              'Authorization': `Bearer ${token}`,
            },
          });

          if (response.ok) {
            const blob = await response.blob();
            const url = URL.createObjectURL(blob);
            setThumbSrc(url);
          } else {
            console.error('Error fetching thumbnail:', response.statusText);
          }
        } catch (error) {
          console.error('Fetch error:', error);
        }
      }
    };

    fetchThumbnail();
  }, [document.thumbArchive]);

  return (
    <>
      <IonCard
        button
        routerLink={
          massiveSign && segment === "pending" ? undefined : `/app/acuerdos/firma/${document.id}`
        }
        style={{ height: "285px" }}
      >
        <IonCardHeader
          style={{ padding: 0, display: "flex", justifyContent: "center", background: "#cccccc" }}
        >
          <img
            src={thumbSrc}
            alt="Imagen documento"
            style={{
              height: "168px",
              objectFit: "cover",
              background: "white",
            }}
          />
          {massiveSign && segment === "pending" && (
            <div
              style={{
                position: "absolute",
                top: "22px",
                left: "15px",
              }}
            >
              <IonCheckbox
                checked={document.checked ? document.checked : false}
                onFocus={() => setHasFocus(true)}
                onIonChange={() => {
                  hasFocus && dispatch(setCheck(document)) && setHasFocus(false);
                }}
              />
            </div>
          )}

          <div
            style={{
              position: "absolute",
              top: "22px",
              right: "15px",
            }}
          >
            <DocumentStatusTag document={document} />
          </div>
        </IonCardHeader>
        <IonCardContent>
          <IonText color="primary">
            <h1
              style={{ fontWeight: 500, height: "60px", fontSize: 20 }}
              className="custom-line-clamp"
            >
              {document.title}
            </h1>
          </IonText>

          <h3>
            <IonIcon icon={personOutline} />
            <IonText class="ion-padding-start">{document.author?.name}</IonText>
          </h3>

          <h4>
            <IonIcon icon={calendarOutline} />
            <IonText class="ion-padding-start">{document.createdAt || ""}</IonText>

            <IonIcon icon={bookmarkOutline} class="ion-padding-start" />
            <IonText class="ion-padding-start">{`${document.category?.name}`}</IonText>
          </h4>
        </IonCardContent>
      </IonCard>
    </>
  );
};